import React from 'react'

function TestAndLiveMode() {
    return (
        <div class="idocs-content">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <section id="idocs_content">
                            <h2>Test & live mode</h2>
                            <hr />
                            <p>
                            Documentation and examples for displaying inline and multiline blocks of code</p>
                        </section>
                        
                    </div>
                    <div class="col-md-4 extreme-rt-div">
                        
                    </div>
                </div>
            </div>
        </div>

    )
}

export default TestAndLiveMode